import React from 'react'
import { useRef, useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import PrivateNavbar from '../layouts/PrivateNavbar'
import "../util/helperfunctions"
import jwt_decode from "jwt-decode"
import { dateTimeConverter, format24h } from '../util/helperfunctions'
import { config } from '../constants/Constants'

export default function AddMealItem() {
  const navigate = useNavigate()

  {/* check if jwt else go to sign in */}
  const [jwt, setJwt] = useState()
  useEffect(() => {
    const jwt = JSON.parse(localStorage.getItem(config.WELLBEINGv1_JWT))
    if(jwt){
      let decodedJwt = jwt_decode(jwt)
      let currentDate = new Date()
      if (decodedJwt.exp * 1000 < currentDate.getTime()){
        localStorage.setItem(config.WELLBEINGv1_JWT, null)
        navigate("/signin")
      }else{
        setJwt(jwt)
      }
    }else{
      navigate("/signin")
    }
  }, [])

  const [errors, setErrors] = useState()

  const [mealsize, setMealsize] = useState("medium")

  const mealDateElement = useRef()
  const mealTimeElement = useRef()
  const mealDescElement = useRef()
  const mealNoteElement = useRef()

  useEffect(() => {
    {/* add current date and itme to inputs */}
    const [nowDate, nowTime] = dateTimeConverter(new Date())
  
    mealDateElement.current.value = nowDate
    mealTimeElement.current.value = nowTime
  }, [])

  const handleSubmit = (e) => {
    setErrors(null)
    e.preventDefault()

    const mealDate = mealDateElement.current.value
    const mealTime = mealTimeElement.current.value
    const mealDesc = mealDescElement.current.value
    const mealNote = mealNoteElement.current.value

    fetch(config.BASE_URL+"/meals", {
      headers: {
        "content-type": "application/json",
        "authorization": "Bearer " + jwt
      },
      method: "POST",
      body: JSON.stringify({
        "date": mealDate,
        "time": mealTime,
        "size": mealsize,
        "meal": mealDesc,
        "note": mealNote
      })
    }).then(res => {
      if(res.status === 201){
        mealDescElement.current.value = ""
        mealNoteElement.current.value = ""
        return
      }
      return res.json().then(data => {
        throw data
      })
    }).catch(err => {
      setErrors(err)
    })
    
  }

  return (
    <>
        <PrivateNavbar />

        <nav className='m-2'>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/meals">Meals</Link></li>
            <li className="breadcrumb-item active">Meal Item</li>
          </ol>
        </nav>

        <div className="card">
          <div className="card-header">
            <h3>Add Meal Item</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Date: </label>
                <input type="date" className="form-control" ref={mealDateElement} />
                <p className="form-text">*dd/mm/yyyy</p>
              </div>
              <div className="mb-3">
                <label className="form-label">Time: </label>
                <input type="time" className="form-control" ref={mealTimeElement} />
              </div>
              <div className="mb-3">
                <div className="btn-group">
                  <input type="radio" className="btn-check" name="mealsize" id="mealsize1" value="light" checked={mealsize === "light"} onChange={(e) => setMealsize(e.target.value)}/>
                  <label className="btn btn-outline-primary" for="mealsize1">light</label>

                  <input type="radio" className="btn-check" name="mealsize" id="mealsize2" value="medium" checked={mealsize === "medium"} onChange={(e) => setMealsize(e.target.value)}/>
                  <label className="btn btn-outline-primary" for="mealsize2">medium</label>

                  <input type="radio" className="btn-check" name="mealsize" id="mealsize3" value="heavy" checked={mealsize === "heavy"} onChange={(e) => setMealsize(e.target.value)}/>
                  <label className="btn btn-outline-primary" for="mealsize3">heavy</label>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Meal: </label>
                <input autoFocus type="text" className="form-control" ref={mealDescElement} />
              </div>
              <div className="mb-3">
                <label className="form-label">Note: </label>
                <input type="text" className="form-control" ref={mealNoteElement} />
                <p className="form-text">*optional</p>
              </div>

              <button type="submit" className="btn btn-primary mb-3">Submit</button>

              {(errors) && (
                <div className="alert alert-danger">
                  {errors['error(s)']?.map(e => {return <p>{e}</p>})}
                </div>
              )}

            </form>
          </div>
        </div>
    </>
    
  )
}
